// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__UCH-l","rootCenter":"LoadMoreObserver_rootCenter__3IObv","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3MmFo"};